import styled from '@emotion/styled';
import { Counter } from '../atoms/Counter';
import { FormField } from './FormField';

interface CounterFieldProps {
  label: string;
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  required?: boolean;
  error?: string;
  disabled?: boolean;
  className?: string;
}

const ErrorMessage = styled.span`
  display: block;
  margin-top: ${(props) => props.theme.spacing(0.5)};
  color: ${(props) => props.theme.colors.state.alert[1000]};
  font-family: ${(props) => props.theme.typography.fontFamily};
  font-size: ${(props) => props.theme.typography.captionRegular.fontSize};
  font-weight: ${(props) => props.theme.typography.captionRegular.fontWeight};
`;

export const CounterField = ({
  label,
  value,
  onChange,
  min = 5,
  max = 50,
  required = false,
  error,
  disabled = false,
  className,
}: CounterFieldProps) => {
  return (
    <FormField label={label} required={required} className={className}>
      <Counter value={value} onChange={onChange} min={min} max={max} disabled={disabled} />
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </FormField>
  );
};
